<script setup>
import { getFileIcon } from '@/configs/files';

const props = defineProps({
  link: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  ext: {
    type: String,
    default: undefined,
  },
  size: {
    type: String,
    default: undefined,
  },
  date: {
    type: String,
    default: undefined,
  },

  textSize: {
    type: String,
    default: undefined,
    validator(textSize) {
      return ['small'].includes(textSize);
    },
  },
});

const iconName = computed(() => getFileIcon(props.ext));
</script>

<template>
  <NuxtLink :to="link" target="_blank" class="ui-file-link link">
    <p
      v-if="text"
      class="ui-file-link__font ui-file-link__font--text"
      :class="{ [`ui-file-link__font--text-size--${textSize}`]: textSize }"
    >
      {{ $tp(text) }}
    </p>

    <div class="ui-file-link__info">
      <div v-if="ext" class="ui-file-link__extension">
        <img
          :src="`/images/files/${iconName}.svg`"
          :alt="ext"
          class="ui-file-link__img"
        />

        <span class="ui-file-link__font ui-file-link__font--extension">
          {{ $tp(ext) }}
        </span>
      </div>

      <span
        v-if="size"
        class="ui-file-link__font ui-file-link__font--properties"
      >
        {{ $tp(size) }}
      </span>

      <div v-if="date" class="ui-file-link__date">
        <span class="ui-file-link__font ui-file-link__font--properties">
          {{ $tp(useFormatDate(date)) }}
        </span>
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped lang="scss">
.ui-file-link {
  &__font {
    &--text {
      font-size: em(32);
      line-height: em(35, 32);

      @include media-breakpoint-down(sm) {
        font-size: em(20);
        line-height: em(22, 20);
      }
    }

    &--text-size {
      &--small {
        font-size: em(18);
        line-height: em(20, 18);

        @include media-breakpoint-down(sm) {
          font-size: em(16);
          line-height: em(18, 16);
        }
      }
    }

    &--extension {
      font-size: em(18);
      line-height: em(23, 18);
      text-transform: uppercase;

      @include media-breakpoint-down(sm) {
        font-size: em(16);
        line-height: em(20, 16);
      }
    }

    &--properties {
      font-weight: 250;
      font-size: em(18);
      line-height: em(23, 18);

      @include media-breakpoint-down(sm) {
        font-size: em(16);
        line-height: em(20, 16);
      }
    }
  }

  &__info {
    display: flex;
    align-items: center;
    margin-top: em(16);
    color: $color-gray-2;

    @include media-breakpoint-down(sm) {
      margin-top: em(15);
    }
  }

  &__extension {
    color: $color-black;
    display: flex;
    align-items: center;
    margin-right: em(8);
    gap: em(7);
  }

  &__img {
    width: em(23);
    height: em(23);
    object-fit: contain;

    @include media-breakpoint-down(sm) {
      width: em(18);
      height: em(18);
    }
  }

  &__date {
    margin-left: em(30);

    @include media-breakpoint-down(sm) {
      margin-left: em(21);
    }
  }
}
</style>
